export const indexedArray = (length: number) =>
  Array.from(Array(length)).map((_, index) => index);
